import * as React from 'react';
import { joinClasses } from '../../../../../../Utils/className.util';
// @ts-ignore
import styles from './UserPickerItem.module.scss';
import UserAvatar from '../../../../../User/Components/UserAvatar/UserAvatar';

interface Props {
	user: UserItem;
	isSelected?: boolean;
	onClick?: (userId: string) => void;
}

export interface UserItem {
	id: string;
	fullName: string;
	firstName: string;
	lastName: string;
	profileImageUrl: string | null;
}

const UserPickerAdd: React.FC<Props> = ({
	user,
	onClick,
	isSelected = false,
}) => {
	const handleClick = () => {
		onClick?.(user.id);
	};

	return (
		<div
			onClick={handleClick}
			className={joinClasses([
				styles.wrapper,
				isSelected ? styles.selected : '',
			])}
		>
			<div className={styles.avatar}>
				<UserAvatar
					userId={user.id}
					profileImageUrl={user.profileImageUrl || undefined}
				/>
			</div>
			<div className={styles.text}>{user.firstName}</div>
		</div>
	);
};

export default UserPickerAdd;
